import React, { useState, useEffect, useMemo } from "react";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import {
  Box,
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardActions,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Divider,
  Fade,
  Avatar,
  Badge,
  Select,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Breadcrumbs,
  tooltipClasses,
} from "@mui/material";
import Poetlogopen from "../../static/POET_Logo_Pen.png"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Grid2 from "@mui/material/Unstable_Grid2";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Search,
  Add,
  Delete,
  FileCopy,
  GetApp,
  Sort,
  ViewModule,
  MoreVert,
  Link as LinkIcon,
  MenuBook,
  Description,
  Language,
  CloudDownload,
  Close,
  AssignmentTurnedIn,
  ExpandMore,
  ContentCopy as ContentCopyIcon,
  OpenInNew,
  EditRoad,
  Edit,
  AutoFixHigh,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { checkAIRequestLimit } from "../aiRequestLimit";
import citationService from "../../services/citationService";
import { useSelector } from "react-redux";
import Loader from "../../utils/loader";
import { addUserLogs } from "../../services/userLogServices";
import SubscriptionRequired from "../../components/SubscriptionRequired";
// import { useCheckFeatureAccess } from "../../CheckFeature";
import { useCheckSubscriptionPlanAccess } from "../../components/SubscriptionAccess";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  zIndex: 10000,
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "#1976d2",
    boxShadow: theme.shadows[3],
    fontSize: 12,
    border: "1px solid #e0e0e0",
  },
}));
const citationStyles = [
  "AMA 10th edition",
  "American Chemical Society",
  "APA 11th edition",
  "APA 6th edition",
  "APA 7th edition",
  "Chicago author",
];

const sourceTypes = [
  { value: "Book Chapter", name: "BOOK CHAPTER" },
  { value: "Video", name: "VIDEO" },
  { value: "Online Dictionary Entry", name: "ONLINE DICTIONARY ENTRY" },
  { value: "Online News Article", name: "ONLINE NEWS ARTICLE" },
  { value: "Image", name: "IMAGE" },
  { value: "Report", name: "REPORT" },
  { value: "Website", name: "WEBSITE" },
];

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor =
    type === "success"
      ? "#4caf50"
      : type === "error"
        ? "#f44336"
        : type === "warning"
          ? "#ff9800"
          : "#2196f3";

  return (
    <Box
      sx={{
        position: "fixed",
        top: 20,
        right: 20,
        bgcolor: bgColor,
        color: "white",
        px: 3,
        py: 2,
        borderRadius: 2,
        boxShadow: 3,
        zIndex: 9999,
        minWidth: 250,
      }}
    >
      {message}
    </Box>
  );
};

const stripHtmlTags = (text) => {
  if (!text) return "";
  return text.replace(/<[^>]*>/g, "");
};

const cleanCitationData = (citation) => {
  if (!citation) return citation;

  const cleaned = { ...citation };

  if (cleaned.title) cleaned.title = stripHtmlTags(cleaned.title);
  if (cleaned.fullCitation)
    cleaned.fullCitation = stripHtmlTags(cleaned.fullCitation);
  if (cleaned.description)
    cleaned.description = stripHtmlTags(cleaned.description);
  if (cleaned.websiteName)
    cleaned.websiteName = stripHtmlTags(cleaned.websiteName);
  if (cleaned.contributors && Array.isArray(cleaned.contributors)) {
    cleaned.contributors = cleaned.contributors.map((contributor) => ({
      ...contributor,
      firstName: contributor.firstName
        ? stripHtmlTags(contributor.firstName)
        : "",
      lastName: contributor.lastName ? stripHtmlTags(contributor.lastName) : "",
      middleName: contributor.middleName
        ? stripHtmlTags(contributor.middleName)
        : "",
      suffix: contributor.suffix ? stripHtmlTags(contributor.suffix) : "",
    }));
  }

  return cleaned;
};

const ModernCitationGenerator = ({ userId }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [initialCitations, setInitialCitations] = useState([]);
  const [citations, setCitations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [citationStyle, setCitationStyle] = useState("APA 7th edition");
  const [searchInput, setSearchInput] = useState("");
  const [downloadAnchor, setDownloadAnchor] = useState(null);
  const [groupByAnchor, setGroupByAnchor] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [cardMenuAnchor, setCardMenuAnchor] = useState(null);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [websiteData, setWebsiteData] = useState(null);
  const [displayByDate, setDisplayByDate] = useState(false);
  const [totalSearchedSource, setTotalSearchedSource] = useState(0);
  const [totalSource, setTotalSource] = useState(0);
  const [toast, setToast] = useState(null);
  const [showManualModal, setShowManualModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCitation, setEditingCitation] = useState(null);
  const [subReqOpen, setSubReqOpen] = useState(false);
  const history = useHistory();
  const accessToCitationScreen = useCheckSubscriptionPlanAccess("citation");
  const accessToCiteManually = useCheckSubscriptionPlanAccess("citeManually");
  const [isFeatureInside, setIsFeatureInside] = useState(false);
  const [loading, setLoading] = useState(false);
  const userDetails = useSelector((user) => user);

  //  const userID = userId ? userId : userDetails.user.currentUser._id;

  const token = sessionStorage.getItem("token");

  const getUserIdentity = () => {
    const token =
      sessionStorage.getItem("token") || localStorage.getItem("token");

    if (!token) return null;

    try {
      const decoded = jwtDecode(token);

      if (decoded.role === "guest") {
        return { machineId: decoded.machineId };
      }

      return { userId: decoded._id };
    } catch (err) {
      console.error("Invalid token");
      return null;
    }
  };


  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    return () => { };
  }, []);

  useEffect(() => {
    if (accessToCitationScreen == false) {
      setSubReqOpen(true);
    }
  }, [accessToCitationScreen]);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    websiteName: "",
    url: "",
    contributors: [
      {
        firstName: "",
        lastName: "",
        middleName: "",
        suffix: "",
        position: "Author",
      },
    ],
    publicationDate: { year: "", month: "", day: "" },
    accessDate: { year: "", month: "", day: "" },
  });

  const showToast = (message, type = "info") => {
    setToast({ message, type });
  };

  // Function to handle view source navigation
  const handleViewSource = (url) => {
    if (url && url !== "N/A") {
      // Ensure URL has proper protocol
      let formattedUrl = url;
      if (!/^https?:\/\//i.test(url)) {
        formattedUrl = "https://" + url;
      }

      // Open URL in new tab
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    } else {
      showToast("No URL available for this citation", "warning");
    }
  };

  // SweetAlert Delete Confirmation Function
  const permanentDeleteCitation = async (
    citation,
    isBulk = false,
    selectedCitations = [],
  ) => {
    swal({
      title: "Permanent Deletion",
      text: isBulk
        ? `Do you want to permanently delete ${selectedCitations.length} citation(s)?`
        : "Do you want to permanently delete this citation?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (permanentDelete) => {
      if (permanentDelete) {
        setLoading(true);
        try {
          let response;
          if (isBulk) {
            const selectedIds = selectedCitations.map(
              (citation) => citation._id,
            );
            response =
              await citationService.deleteSelectedCitations(selectedIds);
          } else {
            response = await citationService.deleteCitation(citation._id);
          }

          console.log("Backend Response:", response);
          if (response.status === 200) {
            showToast(
              isBulk
                ? "Citations deleted successfully"
                : "Citation deleted successfully",
              "success",
            );
            fetchCitationDetails();

            const data = {
              userId: sessionStorage.getItem("userId"),
              organizationId: sessionStorage.getItem("organizationId"),
              actionType: "deleteCitation",
            };

            const addLogs = await addUserLogs(data);
            if (addLogs.status !== 200) {
              showToast(addLogs.message, "error");
            }
          } else {
            showToast(
              isBulk
                ? "Citations deletion failed!"
                : "Citation deletion failed!",
              "error",
            );
          }
        } catch (error) {
          console.error("Error calling backend API:", error.message);
          showToast(
            isBulk ? "Error deleting citations" : "Error deleting citation",
            "error",
          );
        } finally {
          setLoading(false);
        }
      } else {
        swal(isBulk ? "Your citations are safe!" : "Your citation is safe!");
      }
    });
  };

  const fetchCitationDetails = async () => {
    try {
      const email = sessionStorage.getItem("currentUserEmail");
      let data = { email };
      const response = await citationService.getCitationDetails(data);
      if (response.status === 200) {
        const reversedCitations = response.citationDetails.reverse();

        // Clean the citations by removing HTML tags
        const cleanedCitations = reversedCitations.map((citation) =>
          cleanCitationData(citation),
        );

        setInitialCitations(cleanedCitations);
        setTotalSource(cleanedCitations.length);
        setTotalSearchedSource(cleanedCitations.length);
        const citationsWithCheckState = cleanedCitations.map((citation) => ({
          ...citation,
          isChecked: false,
        }));
        setCitations(citationsWithCheckState);
        setDisplayByDate(false);
      } else {
        console.error("Error fetching citation details:", response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  useEffect(() => {
    fetchCitationDetails();
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setSearchInput("");
    setWebsiteData(null);
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setCitations(citations.map((c) => ({ ...c, isChecked })));
  };

  const handleCardCheck = (id) => {
    const updatedCitations = citations.map((c) =>
      c._id === id ? { ...c, isChecked: !c.isChecked } : c,
    );
    setCitations(updatedCitations);

    const allChecked =
      updatedCitations.length > 0 && updatedCitations.every((c) => c.isChecked);
    const someChecked = updatedCitations.some((c) => c.isChecked);

    if (allChecked) {
      setSelectAll(true);
    } else if (someChecked) {
      setSelectAll(false);
    } else {
      setSelectAll(false);
    }
  };

  const selectedCount = citations.filter((c) => c.isChecked).length;
  const totalCount = citations.length;

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value.toLowerCase();
    setSearchTerm(newSearchTerm);
    const filteredCitations = initialCitations.filter((citation) =>
      citation.title.toLowerCase().includes(newSearchTerm),
    );
    setCitations(newSearchTerm ? filteredCitations : initialCitations);
    setTotalSearchedSource(
      newSearchTerm ? filteredCitations.length : initialCitations.length,
    );
  };

  const handleSortClick = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);
    const sortedCitations = [...citations].sort((a, b) => {
      const titleA = a.title.toUpperCase();
      const titleB = b.title.toUpperCase();
      return newSortOrder === "asc"
        ? titleA.localeCompare(titleB)
        : titleB.localeCompare(titleA);
    });
    setCitations(sortedCitations);
    setInitialCitations(sortedCitations);
  };

  const handleCitationStyleChange = (event) => {
    setCitationStyle(event.target.value);
  };

  const handleCopySelected = () => {
    const selectedCitations = citations.filter((c) => c.isChecked);
    if (selectedCitations.length === 0) {
      showToast("Select citations to copy", "warning");
      return;
    }
    const copiedText = selectedCitations
      .map(
        (c) =>
          `Title: ${c.title}\nFull Citation: ${c.fullCitation}\nIn-Text Citation: ${c.publicationDate.year}\nCitation Style: ${c.textStyle}\n\n`,
      )
      .join("");
    navigator.clipboard.writeText(copiedText);
    showToast("Citations copied to clipboard!", "success");
  };

  // Updated handleDeleteSelected with SweetAlert
  const handleDeleteSelected = async () => {
    const selectedCitations = citations.filter(
      (citation) => citation.isChecked,
    );
    if (selectedCitations.length === 0) {
      showToast("Select citations to delete", "warning");
      return;
    }

    permanentDeleteCitation(null, true, selectedCitations);
  };

  // Updated handleDeleteCitation with SweetAlert
  const handleDeleteCitation = async (id) => {
    const citation = citations.find((c) => c._id === id);
    if (citation) {
      permanentDeleteCitation(citation, false);
    }
  };

  const handleCopyCitation = (citation) => {
    const text = `Title: ${citation.title}\nFull Citation: ${citation.fullCitation}\nIn-Text Citation: ${citation.publicationDate.year}\nCitation Style: ${citation.textStyle}`;
    navigator.clipboard.writeText(text);
    showToast("Text copied", "success");
  };

  const handleGroupBy = (type) => {
    setGroupByAnchor(null);

    if (type === "No Group") {
      setCitations(initialCitations);
      setDisplayByDate(false);
    } else if (type === "Source Type") {
      const groupedCitations = {};
      initialCitations.forEach((citation) => {
        const sourceType = citation.sourceType || "Unknown";
        if (!groupedCitations[sourceType]) {
          groupedCitations[sourceType] = [];
        }
        groupedCitations[sourceType].push(citation);
      });

      const sortedCitations = Object.values(groupedCitations).flat();
      setCitations(sortedCitations);
      setDisplayByDate(false);
    } else if (type === "Published Year") {
      setDisplayByDate(true);
    }
  };

  const handleDownload = async (format) => {
    setDownloadAnchor(null);
    const selectedCitations = citations.filter((c) => c.isChecked);
    if (selectedCitations.length === 0) {
      showToast("Select citations to download", "warning");
      return;
    }

    try {
      switch (format) {
        case "MS-Word":
          const wordContent = selectedCitations
            .map(
              (citation, index) =>
                `Citation ${index + 1}:\n` +
                `Title: ${citation.title}\n` +
                `Full Citation: ${citation.fullCitation}\n` +
                `In-Text Citation: ${citation.publicationDate.year}\n` +
                `Citation Style: ${citation.textStyle}\n` +
                `Source Type: ${citation.sourceType}\n` +
                `URL: ${citation.url || "N/A"}\n` +
                `Description: ${citation.description || "N/A"}\n` +
                `---\n`,
            )
            .join("\n");

          downloadFile(wordContent, "citations.doc", "application/msword");
          break;

        // case "BibTeX":
        //   const bibtexContent = selectedCitations
        //     .map((citation, index) =>
        //       `@article{citation${index + 1},\n` +
        //       `  title = {${citation.title}},\n` +
        //       `  author = {${citation.contributors?.[0]?.firstName || 'Unknown'} ${citation.contributors?.[0]?.lastName || 'Author'}},\n` +
        //       `  year = {${citation.publicationDate.year}},\n` +
        //       `  journal = {${citation.sourceType}},\n` +
        //       `  url = {${citation.url || ''}}\n` +
        //       `}`
        //     )
        //     .join("\n\n");

        //   downloadFile(bibtexContent, "citations.bib", "application/x-bibtex");
        //   break;

        case "PDF":
          await generatePDF(selectedCitations);
          break;

        default:
          showToast("Unsupported format", "error");
          return;
      }

      showToast(
        `Downloaded ${selectedCitations.length} citations as ${format}`,
        "success",
      );
    } catch (error) {
      console.error("Download error:", error);
      showToast("Error downloading file", "error");
    }
  };

  const downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(url), 100);
  };

  const generatePDF = (selectedCitations) => {
    return new Promise((resolve) => {
      const pdf = new jsPDF();
      let yPosition = 20;
      const lineHeight = 7;
      const pageHeight = pdf.internal.pageSize.height;
      const margin = 20;
      const maxWidth = 170;

      pdf.setFontSize(16);
      pdf.setFont(undefined, "bold");
      pdf.text("CITATIONS EXPORT", margin, yPosition);
      yPosition += lineHeight * 2;

      pdf.setFontSize(10);
      pdf.setFont(undefined, "normal");
      pdf.text(
        `Generated on: ${new Date().toLocaleDateString()}`,
        margin,
        yPosition,
      );
      yPosition += lineHeight;
      pdf.text(
        `Total Citations: ${selectedCitations.length}`,
        margin,
        yPosition,
      );
      yPosition += lineHeight;
      pdf.text(`Citation Style: ${citationStyle}`, margin, yPosition);
      yPosition += lineHeight * 2;

      selectedCitations.forEach((citation, index) => {
        if (yPosition > pageHeight - 60) {
          pdf.addPage();
          yPosition = margin;
        }

        pdf.setFontSize(12);
        pdf.setFont(undefined, "bold");
        pdf.text(`Citation ${index + 1}:`, margin, yPosition);
        yPosition += lineHeight;

        pdf.setFontSize(10);
        pdf.setFont(undefined, "normal");

        const addWrappedText = (text, isBold = false) => {
          if (isBold) {
            pdf.setFont(undefined, "bold");
          }

          const lines = pdf.splitTextToSize(text, maxWidth);
          lines.forEach((line) => {
            if (yPosition > pageHeight - 20) {
              pdf.addPage();
              yPosition = margin;
            }
            pdf.text(line, margin, yPosition);
            yPosition += lineHeight;
          });

          if (isBold) {
            pdf.setFont(undefined, "normal");
          }
        };

        addWrappedText(`Title: ${citation.title}`);
        addWrappedText(`Full Citation: ${citation.fullCitation}`);
        addWrappedText(`In-Text Citation: ${citation.publicationDate.year}`);
        addWrappedText(`Citation Style: ${citation.textStyle}`);
        addWrappedText(`Source Type: ${citation.sourceType}`);
        addWrappedText(`URL: ${citation.url || "N/A"}`);

        if (citation.description) {
          addWrappedText(`Description: ${citation.description}`);
        }

        if (citation.contributors && citation.contributors.length > 0) {
          const contributors = citation.contributors
            .map((c) => `${c.firstName} ${c.lastName}`)
            .join(", ");
          addWrappedText(`Contributors: ${contributors}`);
        }

        yPosition += lineHeight;
      });

      pdf.save("citations.pdf");
      resolve();
    });
  };

  const handleCardMenu = (event, id) => {
    setCardMenuAnchor(event.currentTarget);
    setSelectedCardId(id);
  };

  const handleCloseCardMenu = () => {
    setCardMenuAnchor(null);
    setSelectedCardId(null);
  };

  const isValidURL = (url) => {
    try {
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
      }
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname;
      const validUrlPattern = new RegExp(
        "\\.(com|io|org|net|gov|edu|co)$",
        "i",
      );
      return validUrlPattern.test(hostname);
    } catch (e) {
      return false;
    }
  };

  const validateInput = (selectedValue, searchInput) => {
    if (selectedValue === 0 && !isValidURL(searchInput)) {
      showToast("Please enter a valid URL", "warning");
      return false;
    }
    return true;
  };

  // const handleCiteButton = async () => {
  //   let suggestionArray = [];
  //   const identity = getUserIdentity();
  //   const limitKey = identity.userId || identity.machineId;
  //   const checkailimit = await checkAIRequestLimit(limitKey);
  //   console.log(checkailimit, "_checkailimit");
  //   if (checkailimit == false) {
  //     showToast("AI request limit reached.", "warning");
  //     return;
  //   }
  //   if (!searchInput.trim()) {
  //     showToast("Search bar is empty", "warning");
  //     return;
  //   }
  //   let sourceitem = "";
  //   if (selectedTab === 0) {
  //     sourceitem = "Webpage";
  //   } else if (selectedTab === 1) {
  //     sourceitem = "Journal Article";
  //   } else {
  //     sourceitem = "Book";
  //   }
  //   if (validateInput(selectedTab, searchInput)) {
  //     setLoading(true);
  //     try {
  //       let response;
  //       const identity = getUserIdentity();
  //       let isCoAuthor = false;

  //       if (sourceitem === "Webpage") {
  //         response = await citationService.getCheckCitationWebpage(
  //           searchInput,
  //           citationStyle,
  //           sourceitem,
  //           // userId,
  //           isCoAuthor,
  //           ...identity,
  //         );

  //         if (response.status === 200) {
  //           setLoading(false);
  //           console.log("Backend Response:", response);
  //           let responseOutput = response?.data?.output;
  //           const parsedData = JSON.parse(responseOutput[0]);
  //           suggestionArray = parsedData.replacements?.corrections;
  //           console.log("changedJSon_", suggestionArray, parsedData);

  //           // Clean the website data by removing HTML tags
  //           const cleanedWebsiteData = suggestionArray.map((item) =>
  //             cleanCitationData(item),
  //           );
  //           setWebsiteData(cleanedWebsiteData);
  //         }
  //       } else if (sourceitem === "Journal Article") {
  //         response = await citationService.getCheckCitationJournalArticle(
  //           searchInput,
  //           citationStyle,
  //           sourceitem,
  //           // userId,
  //           isCoAuthor,
  //           ...identity,
  //         );

  //         if (response.status === 200) {
  //           setLoading(false);
  //           console.log("Backend Response:", response);
  //           let responseOutput = response?.data?.output;
  //           const parsedData = JSON.parse(responseOutput[0]);
  //           suggestionArray = parsedData.replacements?.corrections;
  //           console.log("changedJSon_", suggestionArray, parsedData);

  //           // Clean the website data by removing HTML tags
  //           const cleanedWebsiteData = suggestionArray.map((item) =>
  //             cleanCitationData(item),
  //           );
  //           setWebsiteData(cleanedWebsiteData);
  //         }
  //       } else {
  //         response = await citationService.getCheckCitationBook(
  //           searchInput,
  //           citationStyle,
  //           sourceitem,
  //           // userId,
  //           isCoAuthor,
  //           ...identity,
  //         );

  //         if (response.status === 200) {
  //           setLoading(false);
  //           console.log("Backend Response:", response);
  //           let responseOutput = response?.data?.output;
  //           const parsedData = JSON.parse(responseOutput[0]);
  //           suggestionArray = parsedData.replacements?.corrections;
  //           console.log("changedJSon_", suggestionArray, parsedData);

  //           // Clean the website data by removing HTML tags
  //           const cleanedWebsiteData = suggestionArray.map((item) =>
  //             cleanCitationData(item),
  //           );
  //           setWebsiteData(cleanedWebsiteData);
  //         }
  //       }
  //     } catch (error) {
  //       setLoading(false);
  //       showToast("Error fetching citation details", "error");
  //       console.error("Error calling backend API:", error.message);
  //     }
  //   }
  // };


  const handleCiteButton = async () => {
    let suggestionArray = [];

    const identity = getUserIdentity();
    const limitKey = identity?.userId || identity?.machineId;

    // const checkailimit = await checkAIRequestLimit(limitKey);

    // if (checkailimit === false) {
    //   showToast("AI request limit reached.", "warning");
    //   return;
    // }

    if (!searchInput.trim()) {
      showToast("Search bar is empty", "warning");
      return;
    }

    let sourceitem = "";
    if (selectedTab === 0) {
      sourceitem = "Webpage";
    } else if (selectedTab === 1) {
      sourceitem = "Journal Article";
    } else {
      sourceitem = "Book";
    }

    if (!validateInput(selectedTab, searchInput)) return;

    setLoading(true);

    try {
      let response;
      let isCoAuthor = false;

      // ✅ FIX: Create ONE payload object
      const payload = {
        text: searchInput,
        citationStyle,
        sourceItem: sourceitem,
        isCoAuthor,
        ...identity, // automatically adds userId OR machineId
      };

      if (sourceitem === "Webpage") {
        response =
          await citationService.getCheckCitationWebpage(payload);
      } else if (sourceitem === "Journal Article") {
        response =
          await citationService.getCheckCitationJournalArticle(payload);
      } else {
        response =
          await citationService.getCheckCitationBook(payload);
      }

      if (response?.status === 200) {
        let responseOutput = response?.data?.output;

        if (!responseOutput || !responseOutput[0]) {
          throw new Error("Invalid response format");
        }

        const parsedData = JSON.parse(responseOutput[0].trim());
        suggestionArray = parsedData?.replacements?.corrections || [];

        const cleanedWebsiteData = suggestionArray.map((item) =>
          cleanCitationData(item)
        );

        setWebsiteData(cleanedWebsiteData);
      } else {
        throw new Error("API returned non-200 status");
      }

    } catch (error) {
      console.error("Error calling backend API:", error);
      showToast("Error fetching citation details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveCitation = async () => {
    const identity = getUserIdentity();
    if (!identity) {
      showToast("User identity not found", "error");
      return;
    }
    const email = sessionStorage.getItem("currentUserEmail");
    try {
      // Clean the citation data before saving
      const cleanedCitationData = cleanCitationData(websiteData[0]);

      const response = await citationService.getAddCitation2(
        {
          ...cleanedCitationData,
          ...identity,
        },
        email,
      );
      console.log("Backend Response:", response);
      if (response.status == 200) {
        showToast("Citation saved successfully", "success");
        fetchCitationDetails();
        setWebsiteData(null);
        const data = {
          // userId: sessionStorage.getItem("userId"),
          // organizationId: sessionStorage.getItem("organizationId"),
          ...identity,
          actionType: "addCitation",
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          showToast(addLogs.message, "error");
        }
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
      showToast("Error saving citation", "error");
    }
  };

  const handleOpenManualModal = () => {
    if (accessToCiteManually == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }
    setFormData({
      title: "",
      description: "",
      websiteName: "",
      url: "",
      contributors: [
        {
          firstName: "",
          lastName: "",
          middleName: "",
          suffix: "",
          position: "Author",
        },
      ],
      publicationDate: { year: "", month: "", day: "" },
      accessDate: { year: "", month: "", day: "" },
    });
    setShowManualModal(true);
  };

  const handleCloseManualModal = () => {
    setShowManualModal(false);
  };

  const handleSaveManualCitation = () => {
    if (!formData.title.trim()) {
      showToast("Please provide citation title.", "error");
      return;
    }

    const newCitation = {
      _id: Date.now().toString(),
      title: formData.title,
      fullCitation: `${formData.contributors[0].lastName}, ${formData.contributors[0].firstName}. (${formData.publicationDate.year}). ${formData.title}.`,
      publicationDate: formData.publicationDate,
      textStyle: citationStyle,
      sourceType:
        selectedTab === 0
          ? "Webpage"
          : selectedTab === 1
            ? "Journal Article"
            : "Book",
      isChecked: false,
      contributors: formData.contributors,
      url: formData.url,
      description: formData.description,
      websiteName: formData.websiteName,
    };

    // Clean the citation data before adding to state
    const cleanedCitation = cleanCitationData(newCitation);

    const updatedCitations = [cleanedCitation, ...citations];
    setCitations(updatedCitations);
    setInitialCitations(updatedCitations);
    setTotalSource(updatedCitations.length);
    setTotalSearchedSource(updatedCitations.length);
    showToast("Citation saved successfully", "success");
    handleCloseManualModal();
  };

  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    window.location.href = "/docTags";
    // history.push(path);
  };

  const handleOpenEditModal = (citation) => {
    setEditingCitation(citation);
    setFormData({
      title: citation.title,
      description: citation.description || "",
      websiteName: citation.websiteName || "",
      url: citation.url || "",
      contributors: citation.contributors || [
        {
          firstName: "",
          lastName: "",
          middleName: "",
          suffix: "",
          position: "Author",
        },
      ],
      publicationDate: citation.publicationDate,
      accessDate: citation.accessDate || { year: "", month: "", day: "" },
    });
    setShowEditModal(true);
    handleCloseCardMenu();
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditingCitation(null);
  };

  const handleSaveEditCitation = () => {
    if (!formData.title.trim()) {
      showToast("Please provide citation title.", "error");
      return;
    }

    const updatedCitations = citations.map((c) => {
      if (c._id === editingCitation._id) {
        const updatedCitation = {
          ...c,
          title: formData.title,
          fullCitation: `${formData.contributors[0].lastName}, ${formData.contributors[0].firstName}. (${formData.publicationDate.year}). ${formData.title}.`,
          publicationDate: formData.publicationDate,
          contributors: formData.contributors,
          url: formData.url,
          description: formData.description,
          websiteName: formData.websiteName,
        };

        // Clean the citation data before updating
        return cleanCitationData(updatedCitation);
      }
      return c;
    });

    setCitations(updatedCitations);
    setInitialCitations(updatedCitations);
    showToast("Citation updated successfully", "success");
    handleCloseEditModal();
  };

  const handleAddContributor = () => {
    setFormData({
      ...formData,
      contributors: [
        ...formData.contributors,
        {
          firstName: "",
          lastName: "",
          middleName: "",
          suffix: "",
          position: "Author",
        },
      ],
    });
  };

  const handleRemoveContributor = (index) => {
    const newContributors = formData.contributors.filter((_, i) => i !== index);
    setFormData({ ...formData, contributors: newContributors });
  };

  const handleUpdateContributor = (index, field, value) => {
    const newContributors = [...formData.contributors];
    newContributors[index][field] = value;
    setFormData({ ...formData, contributors: newContributors });
  };

  const getTabIcon = (index) => {
    switch (index) {
      case 0:
        return <Language sx={{ mr: 1 }} />;
      case 1:
        return <Description sx={{ mr: 1 }} />;
      case 2:
        return <MenuBook sx={{ mr: 1 }} />;
      default:
        return null;
    }
  };

  const getSourceIcon = (sourceType) => {
    switch (sourceType) {
      case "Book":
        return <MenuBook />;
      case "Journal Article":
        return <Description />;
      default:
        return <Language />;
    }
  };

  const yearsArray = [
    ...new Set(
      initialCitations.map((citation) => citation.publicationDate.year),
    ),
  ];

  const filteredCitationsByYear = useMemo(() => {
    const sortedYearsArray = [...yearsArray].sort((a, b) => a - b);

    return sortedYearsArray.map((year) => ({
      year,
      citations: citations.filter((cit) => cit.publicationDate.year === year),
    }));
  }, [citations, yearsArray]);

  const tabs = ["Webpage", "Journal Article", "Book"];

  return (
    <>
      <SubscriptionRequired
        open={subReqOpen}
        setOpen={setSubReqOpen}
        isFeatureInside={isFeatureInside}
        setIsFeatureInside={setIsFeatureInside}
        path={"citation"}
      />
      <Loader loading={loading} />
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          overflowY: "auto",
          overflowX: "hidden",
          bgcolor: "#f5f7fa",
          py: 4,
        }}
      >
        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}

        <Container maxWidth={false} disableGutters sx={{ px: 3 }}>
          <Box sx={{ mb: 3 }}>
            <Paper
              elevation={1}
              sx={{
                p: 2.5,
                bgcolor: "white",
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 1,
                  textShadow: "0 0 10px rgba(192,144,255,0.6)",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "white",
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    mr: 2,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    alt="logo"
                    src={Poetlogopen}
                    style={{
                      height: "28px",
                      width: "28px",
                      objectFit: "contain",
                      bgcolor: 'white',
                      // filter: "drop-shadow(0 0 7px rgba(93, 0, 255, 0.65))",
                      filter: "drop-shadow(0 0 7px rgba(163, 163, 164, 0.65))",
                    }}
                  />
                </Box>
              
              <Breadcrumbs
                separator={
                  <NavigateNextIcon
                    fontSize="small"
                    sx={{ color: "#667eea" }}
                  />
                }
                aria-label="breadcrumb"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: 1,
                  }}
                >
                  <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                  <Link
                    to="/docTags"
                    onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                    style={{
                      textDecoration: "none",
                      color: "#667eea",
                      fontWeight: 500,
                      fontSize: "0.95rem",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(102, 126, 234, 0.08)";
                      e.currentTarget.style.color = "#764ba2";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#667eea";
                    }}
                  >
                    MultiTool AI
                  </Link>
                  <NavigateNextIcon
                    fontSize="small"
                    sx={{ color: "#667eea", mx: 0.5 }}
                  />
                  <Typography
                    sx={{
                      color: "#1a1a1a",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      backgroundColor: "rgba(102, 126, 234, 0.08)",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                    AI Citation Generator
                  </Typography>
                </Box>
              </Breadcrumbs>
              </Box>
            </Paper>
          </Box>
          {/* Header Section */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 3,
              borderRadius: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              boxShadow: "0 4px 20px rgba(102, 126, 234, 0.4)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Typography variant="h4" fontWeight="700" gutterBottom>
                  AI Citation Generator
                </Typography>
                <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                  Generate accurate citations in multiple formats
                </Typography>
              </div>
              {/* <div>
                <Link to="/docTags">
                  <Button
                    variant="contained"
                    sx={{
                      right: 0,
                      top: "20%",
                      whiteSpace: "nowrap",
                      minWidth: "auto",
                      px: 2,
                      fontWeight: 700,
                      backgroundColor: "#ffffff",
                      color: "#1976d2",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    ← Back
                  </Button>
                </Link>
              </div> */}
            </div>
          </Paper>

          {/* Search Section */}
          <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
            {/* Tabs */}
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              sx={{
                mb: 3,
                borderBottom: 1,
                borderColor: "divider",
                "& .MuiTab-root": {
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  textTransform: "none",
                  minHeight: 48,
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={tab}
                  icon={getTabIcon(index)}
                  iconPosition="start"
                  label={tab}
                />
              ))}
            </Tabs>

            {/* Search Input */}
            <Grid2 container spacing={2}>
              <Grid2 xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  placeholder={
                    selectedTab === 0
                      ? "Enter or paste the URL"
                      : selectedTab === 1
                        ? "Search or paste article title, DOI, or URL"
                        : "Search or paste book title, ISBN, or URL"
                  }
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid2>
              <Grid2 xs={12} md={2} lg={2}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={handleCiteButton}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    height: "56px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #5568d3 0%, #653a8b 100%)",
                    },
                  }}
                >
                  Cite
                </Button>
              </Grid2>
              <Grid2 xs={12} md={2} lg={2}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<Add />}
                  size="large"
                  onClick={handleOpenManualModal}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    height: "56px",
                    borderWidth: 2,
                    "&:hover": {
                      borderWidth: 2,
                    },
                  }}
                >
                  Cite Manually
                </Button>
              </Grid2>
            </Grid2>

            {/* Citation Preview Accordion */}
            {websiteData && (
              <Accordion
                sx={{
                  borderRadius: 2,
                  mt: 1,
                  bgcolor: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    borderRadius: "8px 8px 0 0",
                    "&.Mui-expanded": {
                      bgcolor: "primary.main",
                      borderRadius: "8px 8px 0 0",
                    },
                  }}
                >
                  <Typography fontWeight="600">
                    {websiteData[0].title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: "white" }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {websiteData[0].sourceType} |{" "}
                    {websiteData[0].publicationDate.year}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                    <LightTooltip title="Save Citation">
                      <IconButton color="success" onClick={handleSaveCitation}>
                        <AssignmentTurnedIn />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Copy">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          const text = `${websiteData[0].title} - ${websiteData[0].description
                            }\n${websiteData[0].sourceType} | ${websiteData[0].publicationDate.year
                            }\n${websiteData[0].url || "No URL available"}`;
                          navigator.clipboard.writeText(text);
                          showToast("Text copied", "success");
                        }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    </LightTooltip>
                    {websiteData[0].url && (
                      <LightTooltip title="View Source">
                        <IconButton
                          color="info"
                          onClick={() => handleViewSource(websiteData[0].url)}
                        >
                          <OpenInNew />
                        </IconButton>
                      </LightTooltip>
                    )}
                    <LightTooltip title="Close">
                      <IconButton
                        color="error"
                        onClick={() => setWebsiteData(null)}
                      >
                        <Close />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
          </Paper>

          {/* Citations Section */}
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
            {/* Toolbar */}
            <Box sx={{ mb: 2 }}>
              <Grid2 container spacing={2} sx={{ mb: 2 }}>
                <Grid2 xs={12} md={3} lg={3}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography variant="h5" fontWeight="700">
                      Citations
                    </Typography>
                    <Badge
                      badgeContent={totalCount}
                      color="primary"
                      sx={{
                        "& .MuiBadge-badge": {
                          fontSize: "0.85rem",
                          height: "24px",
                          minWidth: "24px",
                        },
                      }}
                    >
                      <Avatar
                        sx={{ width: 32, height: 32, bgcolor: "primary.main" }}
                      >
                        <Description sx={{ fontSize: 18 }} />
                      </Avatar>
                    </Badge>
                  </Box>
                </Grid2>
                <Grid2 xs={12} md={9} lg={9}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      justifyContent: "flex-end",
                      flexWrap: "wrap",
                    }}
                  >
                    <TextField
                      size="small"
                      placeholder="Search citations..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        minWidth: 250,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                      <Select
                        value={citationStyle}
                        onChange={handleCitationStyleChange}
                        sx={{ borderRadius: 2 }}
                      >
                        {citationStyles.map((style) => (
                          <MenuItem key={style} value={style}>
                            {style}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <LightTooltip title="Delete selected">
                      <IconButton
                        onClick={handleDeleteSelected}
                        sx={{
                          border: "2px solid",
                          borderColor: "error.main",
                          color: "error.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "error.light",
                            color: "white",
                          },
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Copy selected">
                      <IconButton
                        onClick={handleCopySelected}
                        sx={{
                          border: "2px solid",
                          borderColor: "primary.main",
                          color: "primary.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "primary.light",
                            color: "white",
                          },
                        }}
                      >
                        <FileCopy />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Download">
                      <IconButton
                        onClick={(e) => setDownloadAnchor(e.currentTarget)}
                        sx={{
                          border: "2px solid",
                          borderColor: "success.main",
                          color: "success.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "success.light",
                            color: "white",
                          },
                        }}
                      >
                        <GetApp />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Sort">
                      <IconButton
                        onClick={handleSortClick}
                        sx={{
                          border: "2px solid",
                          borderColor: "warning.main",
                          color: "warning.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "warning.light",
                          },
                        }}
                      >
                        <Sort />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Group by">
                      <IconButton
                        onClick={(e) => setGroupByAnchor(e.currentTarget)}
                        sx={{
                          border: "2px solid",
                          borderColor: "secondary.main",
                          color: "secondary.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "secondary.light",
                            color: "white",
                          },
                        }}
                      >
                        <ViewModule />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </Grid2>
              </Grid2>

              {/* Select All (Source Checkbox) */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      indeterminate={
                        selectedCount > 0 && selectedCount < totalCount
                      }
                    />
                  }
                  label={
                    <Typography variant="body2" fontWeight={500}>
                      Source ({totalSearchedSource}{" "}
                      {totalSearchedSource !== totalSource
                        ? `out of ${totalSource}`
                        : ""}
                      )
                    </Typography>
                  }
                />
                {selectedCount > 0 && (
                  <Fade in={selectedCount > 0}>
                    <Chip
                      label={`${selectedCount} selected`}
                      color="primary"
                      onDelete={() => {
                        setSelectAll(false);
                        setCitations(
                          citations.map((c) => ({ ...c, isChecked: false })),
                        );
                      }}
                      sx={{ borderRadius: 2 }}
                    />
                  </Fade>
                )}
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {/* Citations Grid */}
            {displayByDate ? (
              filteredCitationsByYear.map(
                ({ year, citations: yearCitations }) => (
                  <Box key={year} sx={{ mb: 4 }}>
                    {yearCitations.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          fontWeight="600"
                          sx={{ mb: 2 }}
                        >
                          {year}
                        </Typography>
                        <Grid2 container spacing={3}>
                          {yearCitations.map((citation) => (
                            <Grid2 xs={12} key={citation._id}>
                              <Card
                                elevation={0}
                                sx={{
                                  border: "2px solid",
                                  borderColor: citation.isChecked
                                    ? "primary.main"
                                    : "divider",
                                  borderRadius: 3,
                                  transition: "all 0.3s",
                                  "&:hover": {
                                    borderColor: "primary.main",
                                    transform: "translateY(-2px)",
                                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                  },
                                }}
                              >
                                <CardContent>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: 2,
                                    }}
                                  >
                                    <Checkbox
                                      checked={citation.isChecked || false}
                                      onChange={() =>
                                        handleCardCheck(citation._id)
                                      }
                                    />
                                    <Avatar
                                      sx={{
                                        bgcolor: "primary.light",
                                        width: 48,
                                        height: 48,
                                      }}
                                    >
                                      {getSourceIcon(citation.sourceType)}
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                      <Typography
                                        variant="h6"
                                        fontWeight="600"
                                        gutterBottom
                                      >
                                        {citation.title}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mb: 2 }}
                                      >
                                        {citation.fullCitation}
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          gap: 1,
                                          flexWrap: "wrap",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Chip
                                          size="small"
                                          label={citation.sourceType}
                                          color="primary"
                                          variant="outlined"
                                          sx={{ borderRadius: 1.5 }}
                                        />
                                        {citation.publicationDate.year && (
                                          <Chip
                                            size="small"
                                            label={
                                              citation.publicationDate.year
                                            }
                                            sx={{ borderRadius: 1.5 }}
                                          />
                                        )}
                                        <Chip
                                          size="small"
                                          label={citation.textStyle}
                                          color="secondary"
                                          variant="outlined"
                                          sx={{ borderRadius: 1.5 }}
                                        />
                                      </Box>
                                    </Box>
                                    <IconButton
                                      onClick={(e) =>
                                        handleCardMenu(e, citation._id)
                                      }
                                    >
                                      <MoreVert />
                                    </IconButton>
                                  </Box>
                                </CardContent>
                                <Divider />
                                <CardActions
                                  sx={{ justifyContent: "flex-end", p: 2 }}
                                >
                                  <Button
                                    size="small"
                                    startIcon={<FileCopy />}
                                    onClick={() => handleCopyCitation(citation)}
                                    sx={{ textTransform: "none" }}
                                  >
                                    Copy
                                  </Button>
                                  <Button
                                    size="small"
                                    startIcon={<Delete />}
                                    color="error"
                                    onClick={() =>
                                      handleDeleteCitation(citation._id)
                                    }
                                    sx={{ textTransform: "none" }}
                                  >
                                    Delete
                                  </Button>
                                </CardActions>
                              </Card>
                            </Grid2>
                          ))}
                        </Grid2>
                      </>
                    )}
                  </Box>
                ),
              )
            ) : (
              <Grid2 container spacing={3}>
                {citations.map((citation) => (
                  <Grid2 xs={12} key={citation._id}>
                    <Card
                      elevation={0}
                      sx={{
                        border: "2px solid",
                        borderColor: citation.isChecked
                          ? "primary.main"
                          : "divider",
                        borderRadius: 3,
                        transition: "all 0.3s",
                        "&:hover": {
                          borderColor: "primary.main",
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        },
                      }}
                    >
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                          }}
                        >
                          <Checkbox
                            checked={citation.isChecked || false}
                            onChange={() => handleCardCheck(citation._id)}
                          />
                          <Avatar
                            sx={{
                              bgcolor: "primary.light",
                              width: 48,
                              height: 48,
                            }}
                          >
                            {getSourceIcon(citation.sourceType)}
                          </Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="h6"
                              fontWeight="600"
                              gutterBottom
                            >
                              {citation.title}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              {citation.fullCitation}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <Chip
                                size="small"
                                label={citation.sourceType}
                                color="primary"
                                variant="outlined"
                                sx={{ borderRadius: 1.5 }}
                              />
                              {citation.publicationDate.year && (
                                <Chip
                                  size="small"
                                  label={citation.publicationDate.year}
                                  sx={{ borderRadius: 1.5 }}
                                />
                              )}
                              <Chip
                                size="small"
                                label={citation.textStyle}
                                color="secondary"
                                variant="outlined"
                                sx={{ borderRadius: 1.5 }}
                              />
                            </Box>
                          </Box>
                          <IconButton
                            onClick={(e) => handleCardMenu(e, citation._id)}
                          >
                            <MoreVert />
                          </IconButton>
                        </Box>
                      </CardContent>
                      <Divider />
                      <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
                        <Button
                          size="small"
                          startIcon={<FileCopy />}
                          onClick={() => handleCopyCitation(citation)}
                          sx={{ textTransform: "none" }}
                        >
                          Copy
                        </Button>
                        <Button
                          size="small"
                          startIcon={<Delete />}
                          color="error"
                          onClick={() => handleDeleteCitation(citation._id)}
                          sx={{ textTransform: "none" }}
                        >
                          Delete
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid2>
                ))}
              </Grid2>
            )}

            {citations.length === 0 && (
              <Box sx={{ textAlign: "center", py: 8 }}>
                <Description
                  sx={{ fontSize: 64, color: "text.disabled", mb: 2 }}
                />
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  No citations found
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Try adjusting your search or create a new citation
                </Typography>
              </Box>
            )}
          </Paper>

          {/* Download Menu */}
          <Menu
            anchorEl={downloadAnchor}
            open={Boolean(downloadAnchor)}
            onClose={() => setDownloadAnchor(null)}
            PaperProps={{
              sx: {
                borderRadius: 2,
                mt: 1,
              },
            }}
          >
            <MenuItem onClick={() => handleDownload("MS-Word")}>
              <CloudDownload sx={{ mr: 1 }} /> MS-Word
            </MenuItem>
            {/* <MenuItem onClick={() => handleDownload("BibTeX")}>
              <CloudDownload sx={{ mr: 1 }} /> BibTeX
            </MenuItem> */}
            <MenuItem onClick={() => handleDownload("PDF")}>
              <CloudDownload sx={{ mr: 1 }} /> PDF
            </MenuItem>
          </Menu>

          {/* Group By Menu */}
          <Menu
            anchorEl={groupByAnchor}
            open={Boolean(groupByAnchor)}
            onClose={() => setGroupByAnchor(null)}
            PaperProps={{
              sx: {
                borderRadius: 2,
                mt: 1,
              },
            }}
          >
            <MenuItem onClick={() => handleGroupBy("No Group")}>
              No Group
            </MenuItem>
            <MenuItem onClick={() => handleGroupBy("Source Type")}>
              Source Type
            </MenuItem>
            <MenuItem onClick={() => handleGroupBy("Published Year")}>
              Published Year
            </MenuItem>
          </Menu>

          {/* Card Options Menu - UPDATED */}
          <Menu
            anchorEl={cardMenuAnchor}
            open={Boolean(cardMenuAnchor)}
            onClose={handleCloseCardMenu}
            PaperProps={{
              sx: {
                borderRadius: 2,
                mt: 1,
              },
            }}
          >
            <MenuItem
              onClick={() => {
                const citation = citations.find(
                  (c) => c._id === selectedCardId,
                );
                if (citation) handleOpenEditModal(citation);
              }}
            >
              <Edit sx={{ mr: 1, fontSize: 20 }} />
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => {
                const citation = citations.find(
                  (c) => c._id === selectedCardId,
                );
                if (citation) handleViewSource(citation.url);
                handleCloseCardMenu();
              }}
            >
              <OpenInNew sx={{ mr: 1, fontSize: 20 }} />
              View Source
            </MenuItem>
          </Menu>

          {/* Manual Citation Modal */}
          <Dialog
            open={showManualModal}
            onClose={handleCloseManualModal}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 3,
              },
            }}
          >
            <DialogTitle
              sx={{ bgcolor: "primary.main", color: "white", fontWeight: 600 }}
            >
              {selectedTab === 0
                ? "Webpage"
                : selectedTab === 1
                  ? "Journal Article"
                  : "Book"}
              <IconButton
                onClick={handleCloseManualModal}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "white",
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid2 container spacing={2} marginTop={2}>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    required
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    multiline
                    rows={2}
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Website Name"
                    value={formData.websiteName}
                    onChange={(e) =>
                      setFormData({ ...formData, websiteName: e.target.value })
                    }
                  />
                </Grid2>

                {/* Contributors */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Contributors
                  </Typography>
                  {formData.contributors.map((contributor, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: "black.100",
                        borderRadius: 2,
                      }}
                    >
                      <Grid2 container spacing={2}>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="First Name"
                            value={contributor.firstName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "firstName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="Last Name"
                            value={contributor.lastName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "lastName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Middle Name"
                            value={contributor.middleName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "middleName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Suffix"
                            value={contributor.suffix}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "suffix",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            {formData.contributors.length > 1 && (
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveContributor(index)}
                              >
                                <Delete />
                              </IconButton>
                            )}
                          </Box>
                        </Grid2>
                      </Grid2>
                    </Box>
                  ))}
                  <Button
                    startIcon={<Add />}
                    onClick={handleAddContributor}
                    sx={{ textTransform: "none" }}
                  >
                    Add Member +
                  </Button>
                </Grid2>

                {/* Publication Date */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Publication Date
                  </Typography>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Year"
                    value={formData.publicationDate.year}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          year: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>
                <Grid2 xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>
                    <Select
                      value={formData.publicationDate.month}
                      label="Month"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          publicationDate: {
                            ...formData.publicationDate,
                            month: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="01">January</MenuItem>
                      <MenuItem value="02">February</MenuItem>
                      <MenuItem value="03">March</MenuItem>
                      <MenuItem value="04">April</MenuItem>
                      <MenuItem value="05">May</MenuItem>
                      <MenuItem value="06">June</MenuItem>
                      <MenuItem value="07">July</MenuItem>
                      <MenuItem value="08">August</MenuItem>
                      <MenuItem value="09">September</MenuItem>
                      <MenuItem value="10">October</MenuItem>
                      <MenuItem value="11">November</MenuItem>
                      <MenuItem value="12">December</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Day"
                    value={formData.publicationDate.day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          day: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>

                {/* Access Date */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Access Date
                  </Typography>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Year"
                    value={formData.accessDate.year}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        accessDate: {
                          ...formData.accessDate,
                          year: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>
                <Grid2 xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>
                    <Select
                      value={formData.accessDate.month}
                      label="Month"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          accessDate: {
                            ...formData.accessDate,
                            month: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="01">January</MenuItem>
                      <MenuItem value="02">February</MenuItem>
                      <MenuItem value="03">March</MenuItem>
                      <MenuItem value="04">April</MenuItem>
                      <MenuItem value="05">May</MenuItem>
                      <MenuItem value="06">June</MenuItem>
                      <MenuItem value="07">July</MenuItem>
                      <MenuItem value="08">August</MenuItem>
                      <MenuItem value="09">September</MenuItem>
                      <MenuItem value="10">October</MenuItem>
                      <MenuItem value="11">November</MenuItem>
                      <MenuItem value="12">December</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Day"
                    value={formData.accessDate.day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        accessDate: {
                          ...formData.accessDate,
                          day: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>

                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="URL"
                    value={formData.url}
                    onChange={(e) =>
                      setFormData({ ...formData, url: e.target.value })
                    }
                    placeholder="Enter the source URL for this citation"
                  />
                </Grid2>
              </Grid2>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={handleCloseManualModal}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveManualCitation}
                variant="contained"
                sx={{
                  textTransform: "none",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                Save Citations
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit Citation Modal */}
          <Dialog
            open={showEditModal}
            onClose={handleCloseEditModal}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 3,
              },
            }}
          >
            <DialogTitle
              sx={{ bgcolor: "primary.main", color: "white", fontWeight: 600 }}
            >
              Edit Citation
              <IconButton
                onClick={handleCloseEditModal}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "white",
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid2 container spacing={2} marginTop={2}>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    required
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    multiline
                    rows={2}
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Website Name"
                    value={formData.websiteName}
                    onChange={(e) =>
                      setFormData({ ...formData, websiteName: e.target.value })
                    }
                  />
                </Grid2>

                {/* Contributors */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Contributors
                  </Typography>
                  {formData.contributors.map((contributor, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: "black.100",
                        borderRadius: 2,
                      }}
                    >
                      <Grid2 container spacing={2}>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="First Name"
                            value={contributor.firstName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "firstName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="Last Name"
                            value={contributor.lastName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "lastName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Middle Name"
                            value={contributor.middleName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "middleName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Suffix"
                            value={contributor.suffix}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "suffix",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            {formData.contributors.length > 1 && (
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveContributor(index)}
                              >
                                <Delete />
                              </IconButton>
                            )}
                          </Box>
                        </Grid2>
                      </Grid2>
                    </Box>
                  ))}
                  <Button
                    startIcon={<Add />}
                    onClick={handleAddContributor}
                    sx={{ textTransform: "none" }}
                  >
                    Add Member +
                  </Button>
                </Grid2>

                {/* Publication Date */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Publication Date
                  </Typography>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Year"
                    value={formData.publicationDate.year}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          year: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>
                <Grid2 xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>
                    <Select
                      value={formData.publicationDate.month}
                      label="Month"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          publicationDate: {
                            ...formData.publicationDate,
                            month: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="01">January</MenuItem>
                      <MenuItem value="02">February</MenuItem>
                      <MenuItem value="03">March</MenuItem>
                      <MenuItem value="04">April</MenuItem>
                      <MenuItem value="05">May</MenuItem>
                      <MenuItem value="06">June</MenuItem>
                      <MenuItem value="07">July</MenuItem>
                      <MenuItem value="08">August</MenuItem>
                      <MenuItem value="09">September</MenuItem>
                      <MenuItem value="10">October</MenuItem>
                      <MenuItem value="11">November</MenuItem>
                      <MenuItem value="12">December</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Day"
                    value={formData.publicationDate.day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          day: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>

                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="URL"
                    value={formData.url}
                    onChange={(e) =>
                      setFormData({ ...formData, url: e.target.value })
                    }
                    placeholder="Enter the source URL for this citation"
                  />
                </Grid2>
              </Grid2>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={handleCloseEditModal}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveEditCitation}
                variant="contained"
                sx={{
                  textTransform: "none",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                Update Citation
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    </>
  );
};
export default ModernCitationGenerator;



